import { render, staticRenderFns } from "./CarouselController.vue?vue&type=template&id=5708ac41&scoped=true"
import script from "./CarouselController.vue?vue&type=script&lang=js"
export * from "./CarouselController.vue?vue&type=script&lang=js"
import style0 from "./CarouselController.vue?vue&type=style&index=0&id=5708ac41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5708ac41",
  null
  
)

export default component.exports